export class Marca{
    constructor(
        public _id: string,
        public nombre: string,
        public descripcion: string,
        public banner: string,

    ){
    }
}